"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const setRatingProjectDecision = (0, graphql_tag_1.default)`
  mutation meetings_questions_setRatingProjectDecision($data: RatingQuestionProjectDecisionMutationInput!) {
    meetings {
      questions {
        setRatingProjectDecision(data: $data) {
          state {
            reaction
            hasComment
          }
          like {
            count
            percent
          }
          dislike {
            count
            percent
          }
        }
      }
    }
  }
`;
exports.default = setRatingProjectDecision;